import React from "react";
import { useNavigate } from "react-router-dom";

import {
  IgButton,
  IgDivider,
  IgLink,
  IgTypography,
} from "@intelligems/ig-theme";
import { TabEnumFe } from "@intelligems/ig-types";
import { Grid, useTheme } from "@mui/material";
import { styled } from "@mui/material/styles";
import { AnalyticStatusChip } from "@src/components/chips/analyticsStatusChip";
import { EXPERIMENT_ROUTES } from "@src/routes/routes";
import { Experience } from "@src/store/slices/experiences/types";
import { dateTimeConverter } from "@src/utils/dateConverters";
import {
  mpClickAnalyticsButton,
  mpClickExperienceTableName,
} from "@src/utils/mixpanel";

interface NewActiveTestProps {
  experience: Experience;
  isLastInList: boolean;
}

export const NewActiveTest = ({
  experience,
  isLastInList,
}: NewActiveTestProps) => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Grid item container direction={"column"}>
      <Grid
        key={experience.id}
        xs
        container
        item
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Grid container item direction={"column"} xs={6}>
          <Grid item>
            <IgLink
              style={{
                textDecoration: "none",
                color: theme.palette.text.primary,
              }}
              onClick={() => {
                mpClickExperienceTableName(
                  experience.status === "pending" ? "edit" : "analytics"
                );
                void navigate(
                  `${EXPERIMENT_ROUTES.Experiment}/${experience.id}?action=edit&type=${experience.type}&tab=${
                    experience.status === "pending"
                      ? TabEnumFe.TEST_GROUPS
                      : TabEnumFe.ANALYTICS
                  }`
                );
              }}
            >
              <IgTypography
                sx={{
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                {experience.name}
              </IgTypography>
            </IgLink>
          </Grid>
          <Grid item>
            <IgTypography variant={"body2"}>
              Started {dateTimeConverter(experience.startedAtTs)}
            </IgTypography>
          </Grid>
        </Grid>
        <Grid item>
          <AnalyticStatusChip experience={experience} />
        </Grid>
        <Grid item>
          <IgLink
            style={{
              textDecoration: "none",
              color: theme.palette.text.primary,
            }}
            onClick={() => {
              mpClickAnalyticsButton(
                experience.name,
                experience.id!,
                "Live test impact details button"
              );
              void navigate(
                `${EXPERIMENT_ROUTES.Experiment}/${experience.id}?action=edit&type=${experience.type}&tab=${
                  experience.status === "pending"
                    ? TabEnumFe.TEST_GROUPS
                    : TabEnumFe.ANALYTICS
                }`
              );
            }}
          >
            <IgButton variant={"outlined"}>View Details</IgButton>
          </IgLink>
        </Grid>
      </Grid>
      {!isLastInList && <IgDivider spacing={"s"} />}
    </Grid>
  );
};
